import { useState, useEffect } from "react";
import { api } from "api";
import { getCategoriaAcopio } from "../../../../utility/utils";
import { CATEGORIAS_ACOPIO } from "../../../../utility/constants";

export const usePesajeBascula = (params) => {
    const { configuraciones, enabled = true, user = null } = params;

    const categoriaAcopio = getCategoriaAcopio(user);
    const pesoManual =
        categoriaAcopio === CATEGORIAS_ACOPIO.PLANTA
            ? configuraciones.peso_ingreso_manual
            : configuraciones.peso_ingreso_manual_acopio;

    const [pesoBascula, setPesoBascula] = useState(null);

    // Obtener el peso de báscula para llenar automáticamente el peso de bascula
    const getPesoBascula = async () => {
        try {
            const response = await api.getPesosBascula();
            if (!response.text) {
                setPesoBascula(null);
                return null;
            }
            setPesoBascula(response.text);
            return response.text;
        } catch (error) {
            console.error(error);
            setPesoBascula(null);

            return null;
        }
    };

    useEffect(() => {
        if (!enabled || pesoManual) {
            setPesoBascula(null);
            return;
        }

        let isActive = true;

        const loop = async () => {
            while (isActive) {
                await getPesoBascula();
                await new Promise((res) => setTimeout(res, 1500));
            }
        };

        loop();

        return () => {
            isActive = false;
        };
    }, [enabled, pesoManual]);

    return {
        pesoManual,
        pesoBascula,
    };
};
